import { Component, OnInit } from '@angular/core';
import { ConnectedApp, ConnectedAppAuth, AuthType } from 'app/models/connected-app';
import { ConnectedAppService } from 'app/services/connected-app.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { finalize } from 'rxjs/operators';

declare var marked: any;

@Component({
  selector: 'app-manage-connected-apps',
  templateUrl: './manage-connected-apps.component.html',
  styleUrls: ['./manage-connected-apps.component.scss']
})
export class ManageConnectedAppsComponent implements OnInit {

  tableLimitSelect = [5, 10, 20, 30, 50, 100];
  selectedTableLimit: number = 5;
  
  tableLoadingIndicator: boolean = false;
  
  connectedApps: ConnectedApp[] = [];
  appIndexToDelete: number = -1;
  appIndexToShowRedirects: number = -1;

  constructor(private connectedAppsService: ConnectedAppService, private toastService: ToastService) { }

  ngOnInit(): void {
    this.refreshApps();
  }

  refreshApps() {
    this.tableLoadingIndicator = true;
    this.connectedAppsService.list().pipe(finalize(() => {this.tableLoadingIndicator = false})).subscribe((c) => {
      this.connectedApps = c;
      this.connectedApps.forEach((a) => {
        (a.auths || []).forEach((auth) => {
          auth.connected_app = {name: a.name, description: a.description} as ConnectedApp;
        });
      });
    }, (err) => {
      this.toastService.error('Cannot load connected apps!');
    });
  }
  onDeleteApp() {
    this.tableLoadingIndicator = true;
    this.connectedAppsService.deleteById(this.connectedApps[this.appIndexToDelete].id).subscribe(() => {
      this.toastService.success('App Disconnected!');
      this.refreshApps();
    }, (err) => {
      this.tableLoadingIndicator = false;
      this.toastService.error('Error disconnecting app!');
    });
  }
  getMarkdownHtml(value: string, el: HTMLElement) {
    el.innerHTML = marked.parse(value);
  }
  hasOauth2(auths: ConnectedAppAuth[]) {
    return auths.find((auth) => auth.type == AuthType.OAUTH2) || false;
  }
  getOAuth2RedirectURIs() {
    if (this.appIndexToShowRedirects == -1) {
      return [];
    }

    let auths: ConnectedAppAuth[] = this.connectedApps[this.appIndexToShowRedirects].auths;
    let redirectURIs = [];
    auths.forEach((a) => {
      if (a.type == AuthType.OAUTH2) {
        redirectURIs.push(this.connectedAppsService.getAuthRedirectUrl(a, true));
        redirectURIs.push(this.connectedAppsService.getAuthRedirectUrl(a, false));
      }
    });
    return redirectURIs;
  }
}
